import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const UNSPLASH_SEARCH_PHOTOS = 'UNSPLASH_SEARCH_PHOTOS'

export const searchPhotosApi = apiCall(
  UNSPLASH_SEARCH_PHOTOS,
  ({
    siteId,
    query,
    page = 1,
    per_page = 24,
  }: {
    siteId: string
    query: string
    page: number
    per_page: number
  }) => {
    const queryString = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
    })

    if (query) {
      queryString.set('query', query)
    } else {
      queryString.set('query', 'random')
    }

    return {
      endpoint: getApiUrl(
        `/api/cms/v1/sites/${siteId}/unsplash?${queryString.toString()}`,
      ),
      method: 'GET',
      headers: appApiHeaders(),
    }
  },
)
